import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CircularProgress,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGetParentStudentsQuery } from "../../../app/parentApiSlice";
import ParentAICredits from "./ParentAICredits";
import UserAvatar from "../../common/UserAvatar";

function StudentCard({ student }) {
  const navigate = useNavigate();
  const fullName = `${student.first_name || ""} ${student.last_name || ""}`.trim();

  return (
    <Card sx={{ height: "100%" }}>
      <CardActionArea
        onClick={() => navigate(`/parent/student/${student.id}`)}
        sx={{ height: "100%", p: 2 }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <UserAvatar
            src={student.photo}
            name={fullName}
            sx={{ width: 72, height: 72, fontSize: "1.5rem" }}
          />
          <Typography variant="h6" align="center" fontWeight="bold">
            {fullName || "—"}
          </Typography>
          {student.reg_number && (
            <Typography variant="body2" color="text.secondary">
              Reg: {student.reg_number}
            </Typography>
          )}
          {student.gender && (
            <Typography variant="body2" color="text.secondary">
              {student.gender}
            </Typography>
          )}
          <Typography variant="caption" color="primary">
            View Details →
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

function ParentDashboard() {
  const [tab, setTab] = React.useState(0);
  const { data: students, isLoading, error } = useGetParentStudentsQuery();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">
          Failed to load students. Please try again.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
        <Tab label="My Children" />
        <Tab label="Credits" />
      </Tabs>

      {tab === 0 && (
        <>
          {!students?.length ? (
            <Typography color="text.secondary">
              No students linked to your account. Please contact the school
              administrator to link your phone number to your child's record.
            </Typography>
          ) : (
            <Grid container spacing={3}>
              {students.map((student) => (
                <Grid item xs={12} sm={6} md={4} key={student.id}>
                  <StudentCard student={student} />
                </Grid>
              ))}
            </Grid>
          )}
        </>
      )}

      {tab === 1 && <ParentAICredits />}
    </Box>
  );
}

export default ParentDashboard;
